function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import CustomerInsightsService from '@/apps/customer-insigths/services/customer_insights_service';
export default {
  name: 'SectionsMaintenanceComponent',
  data: function data() {
    return {
      DIALOG_ADD_SECTION: 'DIALOG_ADD_SECTION',
      DIALOG_DELETE_SECTION: 'DIALOG_DELETE_SECTION',
      keySectionsTable: 0,
      item: null,
      sectionToAdd: ''
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('customer-insights', ['getInitialData'])), {}, {
    onAdd: function onAdd() {
      this.$refs[this.DIALOG_ADD_SECTION].onOpen();
    },
    onOpenDialog: function onOpenDialog(item, dialogName) {
      this.item = item;
      this.$ref[dialogName].onOpen();
    },
    resetForm: function resetForm() {
      this.sectionToAdd = '';
      return this.$refs.formAddSection.resetValidation();
    },
    validate: function validate() {
      return this.$refs.formAddSection.validate();
    },
    onAddSection: function onAddSection(event) {
      var _this = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var params = {
        section: this.sectionToAdd
      };
      CustomerInsightsService.addSection(params).then(function (response) {
        _this.getInitialData();
        _this.keySectionsTable += 1;
        _this.resetForm();
        _this.$refs[_this.DIALOG_ADD_SECTION].onClose();
      });
    },
    onDeleteSection: function onDeleteSection(section) {
      var _this2 = this;
      CustomerInsightsService.deleteSection(section).then(function (response) {
        _this2.getInitialData();
        _this2.keySectionsTable += 1;
      });
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('customer-insights', ['sections'])), {}, {
    items: function items() {
      return this.sections.map(function (section) {
        return {
          section: section
        };
      });
    },
    headers: function headers() {
      return [{
        value: 'section',
        text: 'Section'
      }, {
        value: 'actions',
        text: ''
      }];
    }
  })
};